import React from 'react';

interface LoaderProps {
    message?: string;
    size?: 'sm' | 'md' | 'lg';
    color?: string;
}

const Loader: React.FC<LoaderProps> = ({ message, size = 'md', color = 'blue-600' }) => {
    const sizeClasses = {
        sm: 'h-5 w-5',
        md: 'h-10 w-10',
        lg: 'h-16 w-16'
    };

    if (size === 'sm') {
        return (
            <svg className={`animate-spin ${sizeClasses[size]} text-${color}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center p-8 text-center text-slate-500">
            <svg className={`animate-spin -ml-1 mr-3 ${sizeClasses[size]} text-${color}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <h3 className="mt-4 text-lg font-semibold text-slate-700">IntelOptics Insights is Analyzing...</h3>
            <p className="mt-1 text-sm">{message || 'Processing global intelligence data. This may take a moment.'}</p>
        </div>
    );
};

export default Loader;